module.exports = __webpack_public_path__ + "img/LebaraBrand.b9918caa.svg";